import { decodeHTML } from 'entities';
import moment from 'moment';
import 'moment/locale/ko';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// import { Link } from 'react-router-dom';
import { savePAEAA010History } from '../../redux/reducers/PAEAA010';
import { postPAIAE010Choice, postPAIAE010DelChoice } from '../../services/Api';
import { decodeToken, getSubwayClass } from '../../utils';
const RecruitItem = ({
    item,
    saveHistory = false,
    openPopup,
    showStar,
    showDelete,
    roleAction,
    setRecruitList,
    refreshData,
}) => {
    const dispatch = useDispatch();
    const loggedIn = useSelector(({ auth }) => auth.login.loggedIn);
    const token = useSelector(({ auth }) => auth.login.token);
    const decode = decodeToken(token);
    const [star, setStar] = useState(false);

    const handleSaveHistory = () => {
        if (saveHistory) {
            dispatch(savePAEAA010History({ id: item?.seq }));
        }
    };

    useEffect(() => {
        if (item.isChoice === 'Y') {
            setStar(true);
        } else {
            setStar(false);
        }
    }, [item]);

    const removeStar = () => {
        if (!loggedIn) {
            alert('로그인 후 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_C' && roleAction === 'P') {
            alert('개인회원만 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_P' && roleAction === 'C') {
            alert('치과회원만 이용가능합니다.');
            return;
        }
        if (window.confirm('삭제하시겠습니까?')) {
            setStar(false);
            postPAIAE010DelChoice(item?.choiceSeq)
                .then(() => {
                    if (refreshData) {
                        refreshData();
                    } else {
                        setRecruitList((prevList) =>
                            prevList.map((recruit) =>
                                recruit.seq === item.seq ? { ...recruit, isChoice: 'N' } : recruit,
                            ),
                        );
                    }
                })
                .catch((error) => {
                    setStar(true);
                    console.log(error);
                });
        }
    };

    const activeStar = () => {
        if (!loggedIn) {
            alert('로그인 후 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_C' && roleAction === 'P') {
            alert('치과회원만 이용가능합니다.');
            return;
        } else if (decode?.authorities === 'ROLE_P' && roleAction === 'C') {
            alert('개인회원만 이용가능합니다.');
            return;
        }
        setStar(true);
        postPAIAE010Choice({ tblName: 'Recruit', refSeq: item?.seq, memberID: decode?.memberID })
            .then(({ data }) => {
                if (refreshData) {
                    refreshData();
                } else {
                    setRecruitList((prevList) =>
                        prevList.map((recruit) =>
                            recruit.seq === item.seq ? { ...recruit, isChoice: 'Y', choiceSeq: data.seq } : recruit,
                        ),
                    );
                }
            })
            .catch((error) => {
                setStar(false);
                console.log(error);
            });
    };

    const checkGoodNameCodes = (codes) => {
        const goodNameCodes = item?.goodNameCode?.split(',').map((code) => code.trim());
        return goodNameCodes?.some((code) => codes.includes(code)) || false;
    };

    return (
        <li
            className={`item ${checkGoodNameCodes(['1000', '1001', '1100', '1500', '1501', '1510']) ? 'yellow' : ''} ${item?.fixed === 'Y' ? 'pin' : ''
                } ${checkGoodNameCodes(['2000', '2001', '2500', '2501', '2510']) ? 'purple' : ''}`.trim()}
        >
            <div className={`wrap-column ${showDelete ? 'col5' : ''}`}>
                <div className="column column-1">
                    <div
                        className={`clinic-name ${checkGoodNameCodes(['1000', '1001', '1100', '1500', '1501', '1510']) ? 'start' : ''
                            }`}
                    >
                        <a
                            href={
                                sessionStorage.getItem(`visitedSeq-${item?.seq}`)
                                    ? `/paeaa070-${item?.seq}`
                                    : `/paeaa070-${item?.seq}?bs=1`
                            }
                            target="_blank"
                            rel="noopener noreferrer"
                            className={`${checkGoodNameCodes(['1000', '1001', '1100', '1500', '1501', '1510']) ? 'yellow' : ''}`}
                            onClick={(e) => {
                                if (!sessionStorage.getItem(`visitedSeq-${item?.seq}`)) {
                                    sessionStorage.setItem(`visitedSeq-${item?.seq}`, 'true');
                                }
                                handleSaveHistory();
                            }}
                        >
                            {item?.companyName && decodeHTML(item?.companyName)}
                        </a>

                    </div>
                </div>
                <div
                    className={`column start column-2 ${checkGoodNameCodes(['1000', '1001', '1100', '1500', '1501', '1510']) ? 'start' : ''
                        }`}
                >
                    <div className="wrap-title">
                        <h4 className="item-title">
                            {checkGoodNameCodes(['3520', '3521', '3529', '3020', '3021', '3200']) ? (
                                <i className="icon icon-hot"></i>
                            ) : (
                                ''
                            )}
                            {checkGoodNameCodes(['3010', '3011', '3100', '3510', '3511', '3519']) ? (
                                <i className="icon icon-note"></i>
                            ) : (
                                ''
                            )}
                            {/* <Link
                                to={
                                    sessionStorage.getItem(`visitedSeq-${item?.seq}`)
                                        ? `/paeaa070-${item?.seq}`
                                        : `/paeaa070-${item?.seq}?bs=1`
                                }
                                onClick={() => {
                                    if (!sessionStorage.getItem(`visitedSeq-${item?.seq}`)) {
                                        sessionStorage.setItem(`visitedSeq-${item?.seq}`, 'true');
                                    }
                                    handleSaveHistory();
                                    window.scrollTo({ top: 0 });
                                }}
                            >
                                {decodeHTML(item?.title)}
                            </Link> */}
                            <a
                                href={
                                    sessionStorage.getItem(`visitedSeq-${item?.seq}`)
                                        ? `/paeaa070-${item?.seq}`
                                        : `/paeaa070-${item?.seq}?bs=1`
                                }
                                target="_blank"
                                rel="noopener noreferrer"
                                onClick={() => {
                                    if (!sessionStorage.getItem(`visitedSeq-${item?.seq}`)) {
                                        sessionStorage.setItem(`visitedSeq-${item?.seq}`, 'true');
                                    }
                                    handleSaveHistory();
                                }}
                            >
                                {decodeHTML(item?.title)}
                            </a>

                        </h4>
                    </div>
                    <div className="wrap-row">
                        <ul className="wrap-link">
                            <li>
                                <span>{item?.recruitClass}</span>
                            </li>
                        </ul>
                    </div>
                    <ul className="wrap-position">
                        <li className="region-condition">
                            {item?.regionSiName} &gt; {item?.regionGuName}
                        </li>
                        <li className="subway-tag">
                            {checkGoodNameCodes([
                                '1000',
                                '1001',
                                '1100',
                                '1500',
                                '1501',
                                '1510',
                                '3520',
                                '3521',
                                '3529',
                                '3020',
                                '3021',
                                '3200',
                                '3010',
                                '3011',
                                '3100',
                                '3510',
                                '3511',
                                '3519',
                                '2000',
                                '2001',
                                '2500',
                                '2501',
                                '2510',
                                '5000',
                                '5002',
                            ])
                                ? [...new Set([item?.subwayNum1Name, item?.subwayNum2Name, item?.subwayNum3Name])]
                                    .filter((line) => line !== null)
                                    .map((subway, index) => (
                                        <div
                                            key={index}
                                            className={`subway ${item.goodNameCode !== null ? getSubwayClass(subway) : 'subway-normal'
                                                }`}
                                        >
                                            {subway}
                                        </div>
                                    ))
                                : (() => {
                                    const subways = [
                                        ...new Set([
                                            item?.subwayNum1Name,
                                            item?.subwayNum2Name,
                                            item?.subwayNum3Name,
                                        ]),
                                    ].filter((line) => line !== null);
                                    return subways.length > 0 ? `[ ${subways.join(', ')} ]` : '';
                                })()}
                        </li>
                    </ul>
                </div>
                <div className="column column-3">
                    <div className="blank-row blank-row--end">
                        {item?.applyMethod1 === '001' && (
                            <button
                                className="support"
                                id="support-1"
                                data-type="popup"
                                onClick={() =>
                                    openPopup({
                                        companyName: item?.companyName,
                                        title: item?.title,
                                        recruitCareer: item?.recruitCareer,
                                        recruitForm: item?.recruitForm,
                                        recruitLicense: item?.recruitLicense,
                                        recruitSeq: item?.seq,
                                    })
                                }
                            >
                                즉시지원
                            </button>
                        )}
                    </div>
                    <ul className="wrap-link">
                        <li>
                            <span>
                                {item?.recruitCareer && item?.recruitCareer?.includes(',')
                                    ? item?.recruitCareer?.split(',')[0] + ' 외'
                                    : item?.recruitCareer}
                            </span>
                        </li>
                        <li>
                            <span>
                                {item?.recruitForm && item?.recruitForm?.includes(',')
                                    ? item?.recruitForm?.split(',')[0] + ' 외'
                                    : item?.recruitForm}
                            </span>
                        </li>
                        <li>
                            <span>
                                {item?.recruitLicense && item?.recruitLicense?.includes(',')
                                    ? item?.recruitLicense?.split(',')[0] + ' 외'
                                    : item?.recruitLicense}
                            </span>
                        </li>
                    </ul>
                    <div className="blank-row">
                        {(() => {
                            const isToday = moment(item?.modDate).isSame(moment(), 'day');
                            return (
                                <span className={`update ${isToday ? 'text-update' : 'gray'}`}>
                                    {isToday ? 'update' : `${moment(item?.modDate).format('MM/DD')} 수정`}
                                </span>
                            );
                        })()}
                    </div>
                </div>
                <div className="column column-4">
                    <div className="wrap-meta">
                        {showStar && (
                            <button
                                className={`icon icon-star ${star ? 'active' : ''}`}
                                onClick={(e) => {
                                    e.preventDefault();
                                    star ? removeStar() : activeStar();
                                }}
                            />
                        )}
                        {/* <Link
                            className="icon icon-blank"
                            onClick={(e) => {
                                e.preventDefault();
                                sessionStorage.getItem(`visitedSeq-${item?.seq}`)
                                    ? window.open(`/pajac051-${item?.seq}`, '_blank', 'width=1200,height=1000')
                                    : window.open(`/pajac051-${item?.seq}?bs=1`, '_blank', 'width=1200,height=1000');

                                if (!sessionStorage.getItem(`visitedSeq-${item?.seq}`)) {
                                    sessionStorage.setItem(`visitedSeq-${item?.seq}`, 'true');
                                }
                            }}
                        /> */}
                    </div>
                    <div
                        className={`room-name ${(() => {
                            const diffDays = moment(item?.recruitEnd)
                                .startOf('day')
                                .diff(moment().startOf('day'), 'days');
                            return diffDays === 0 || diffDays === 1 ? 'red' : '';
                        })()}`}
                    >
                        {(() => {
                            const diffDays = moment(item?.recruitEnd)
                                .startOf('day')
                                .diff(moment().startOf('day'), 'days'); // số ngày còn lại

                            if (diffDays === 0) return '오늘마감'; // hôm nay hết hạn
                            if (diffDays === 1) return '내일마감'; // hôm nay hết hạn
                            if (diffDays > 1) return `D-${diffDays}`; // còn số ngày
                            return ''; // đã hết hạn
                        })()}
                    </div>
                    <div className="blank-row blank-row--center">
                        <span className="text-dday-date">
                            ~ {moment(item?.recruitEnd).locale('ko').format('MM/DD (ddd)')}
                        </span>
                    </div>
                </div>
                {showDelete && (
                    <div className="column column-5">
                        <button onClick={removeStar}>
                            <i className="icon icon-trash-2"></i>
                        </button>
                    </div>
                )}
            </div>
        </li>
    );
};

export default RecruitItem;
